"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _internal.useResetIconStyle;
  }
});
var _internal = require("../../theme/internal");